/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'
import { useCallback } from 'react'

import PropTypes from 'prop-types'

import { generatePath } from 'react-router-dom'

import Context from './Context'

/**
 * This is the component description.
 */
const ContextProvider = ({
  urlMap,
  children,
  // ...otherProps
}) => {
  const generateBlogPath = useCallback((key, variables) => generatePath(
    urlMap[key],
    variables,
  ),
  [urlMap])

  return (
    <Context.Provider value={{
      generateBlogPath,
      urlMap,
    }}
    >
      { children }
    </Context.Provider>
  )
}

ContextProvider.propTypes = {
  /**
   * The hash of urls
   */
  urlMap:PropTypes.shape({
    HOME                   :PropTypes.string.isRequired,
    LIST                   :PropTypes.string.isRequired,
    LIST_PAGINATED         :PropTypes.string.isRequired,
    LIST_CATEGORY          :PropTypes.string.isRequired,
    LIST_CATEGORY_PAGINATED:PropTypes.string.isRequired,
    SINGLE                 :PropTypes.string.isRequired,

  }).isRequired,

  /**
   *  The children JSX
   */
  children:PropTypes.node,
}

ContextProvider.defaultProps = {
  // someProp:false
}

export default ContextProvider
